import React, { Component } from 'react';
import * as Config from './../../config/Config';
import * as Common from './../../helpers/Common';
import * as User from './../../helpers/User';
import * as Prevnext from './../../components/Prevnext';
import Recap_list from './Recap_list';
const $=window.$;

class Recap extends Component {
	constructor(props) {
		super(props);
        this.state={
        	lr_count:'',
        	dlr_count:'',
        	lr_lists:[],
        	lr_module_name_lists:[],
        	module_lr_lists:[],
        	module_name_list:[],
        	dlr_wise:[],
        	dlr_wise_list:[],
        	dlr_module_wise:[],
        	dlr_module_wise_list:[],
        	dlr_module_name_lists:[],
        	dlr_lear_count:[],
        	dlr_module_name_lists_count:[],
        	table_lr:[],
        	table_dlr:[],
        	recap_module_list:[],

    };
	}

	componentDidMount() {
		$(".timebox_new").css('display','none');
		this.getRecap();
			// this.showRecapNext();
			// setTimeout(()=>{
			// 	Common.showSmallLeftMenu();				
			// },500)
	}

	getRecap(){
			let learnerID   = Common.getUserData("id", true);
			let pinNo 		= Common.getUserData("pinNo", true);
			let pinID 		= Common.getUserData("pinID", true);
			let corporateID = Common.getUserData("corporateID", true);
			let productID 	= Common.getUserData("productID", true);
			let specialExpiryDate = Common.getUserData("specialExpiryDate", true);

			Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'learning/recap', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
				  'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learnerID:learnerID,
					pinNo:pinNo,
					pinID:pinID,
					corporateID:corporateID,
					productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
               	if(responseJson.status != 0){
								let lr_count  = (responseJson.recap.lr_count!=undefined) ? responseJson.recap.lr_count : '';
								let dlr_count = (responseJson.recap.dlr_count!=undefined) ? responseJson.recap.dlr_count : '0';
								let lr_lists  = (responseJson.recap.lr_lists!=undefined) ? responseJson.recap.lr_lists : '';
								let lr_module_name_lists = (responseJson.recap.lr_module_name_lists!=undefined) ? responseJson.recap.lr_module_name_lists : '';
								let module_lr_lists      = (responseJson.recap.module_lr_lists!=undefined) ? responseJson.recap.module_lr_lists : '';
								let module_name_list     = (responseJson.recap.module_name_list!=undefined) ? responseJson.recap.module_name_list : '';

								let dlr_wise_list        = (responseJson.recap.dlr_wise!=undefined) ? responseJson.recap.dlr_wise : '';
								let dlr_module_wise_list = (responseJson.recap.dlr_module_wise!=undefined) ? responseJson.recap.dlr_module_wise : '';
								 //alert(JSON.stringify(dlr_module_wise_list));
								let dlr_module_name_lists = (responseJson.recap.dlr_module_name_lists!=undefined) ? responseJson.recap.dlr_module_name_lists : '';
								let dlr_module_name_lists_count = (responseJson.recap.dlr_module_name_lists_count!=undefined) ? responseJson.recap.dlr_module_name_lists_count : '';
								
								let dlr_lear_count = (responseJson.recap.dlr_lear_count!=undefined) ? responseJson.recap.dlr_lear_count : '';

								let table_lr  = (responseJson.recap.table_lr!=undefined) ? responseJson.recap.table_lr : '';
								let table_dlr = (responseJson.recap.table_dlr!=undefined) ? responseJson.recap.table_dlr : '';
								 //alert(JSON.stringify(lrroom));dlr_lear_count
								 let recap_module_list = <Recap_list lr_count = {lr_count} dlr_count = {dlr_count}
								  lr_lists = {lr_lists} lr_module_name_lists = {lr_module_name_lists} 
								  module_lr_lists = {module_lr_lists} module_name_list = {module_name_list}
								   dlr_wise_list = {dlr_wise_list} dlr_module_wise_list = {dlr_module_wise_list}
								    dlr_module_name_lists = {dlr_module_name_lists} dlr_lear_count = {dlr_lear_count} 
								    dlr_module_name_lists_count = {dlr_module_name_lists_count} />;
								 this.setState({
										 recap: responseJson.recap,
										 lr_count:lr_count,
										 dlr_count:dlr_count,
										 recap_module_list:recap_module_list,
										 table_lr:table_lr,
										 table_dlr:table_dlr
								 });
					}
								setTimeout(()=>{
									this.getTabs();
									Common.reactLoader("hide");
									Common.downTabClose();
								},1000);
   		 			});
    }

	getTabs(){
	           window.$(this.refs.parentHorizontalTab).easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    let $tab = $(this);
	                    let $info = $('#nested-tabInfo');
	                    let $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });
	       }

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

	render() {
		
	let table_lr = null;
	if(this.state.table_lr != null || this.state.table_lr != undefined){
		table_lr = this.state.table_lr.map((table_val,table_key)=>{
			return  <tr key={`table-tr${table_key}`} bgcolor='#FFFFFF'>
									 	<td  align="center" style={{textAlign:'center'}}>{table_val['lr_room_count']}</td>
									 	<td  align="center" style={{textAlign:'center'}}>{table_val['module_name']}</td>
									 	<td  align="center" style={{textAlign:'center'}}>
										 	<table key={`table-tr-table${table_key}`} cellPadding="0"  cellSpacing="0" border="0">	
										 			<tbody>												
																<tr>
																	<td valign="top"><span className={table_val['component_name']['spanclass']} style={{marginRight:'0'}}></span></td>
																	<td style={{paddingLeft:'15px'}}>
																		<div style={{float:'left'}}><span style={{border:'#FF0000 0px solid'}} className="title_rc">{table_val['component_name']['name']}</span></div>
																		<div style={{float:'left' ,clear:'both'}}><span className="lm_subtitle">{table_val['component_name']['icon']}</span></div>
																		<div style={{float:'left' ,clear:'both', width:'350px'}}><span>{table_val['component_name']['base_line']}</span></div>
																	</td>
																</tr>
													</tbody>
												</table>
											</td>
								  </tr>
		})
	}



		let table_dlr = null;
	if(this.state.table_dlr != null || this.state.table_dlr!= undefined){
		table_dlr = this.state.table_dlr.map((table_val,table_key)=>{
			return  <tr key={`table-tr${table_key}`} bgcolor='#FFFFFF'>
									 	<td  align="center" style={{textAlign:'center'}}>{table_val['lr_room_count']}</td>
									 	<td  align="center" style={{textAlign:'center'}}>{table_val['module_name']}</td>
									 	<td  align="center" style={{textAlign:'center'}}>
									 		<table key={`table-tr-table${table_key}`} cellPadding="0"  cellSpacing="0" border="0">
									 				<tbody>											
																<tr>
																	<td valign="top"><span className={table_val['component_name']['spanclass']} style={{marginRight:'0'}}></span></td>
																	<td style={{paddingLeft:'15px'}}>
																		<div style={{float:'left'}}><span style={{border:'#FF0000 0px solid'}} className="title_rc">{table_val['component_name']['name']}</span></div>
																		<div style={{float:'left' ,clear:'both'}}><span className="lm_subtitle">{table_val['component_name']['icon']}</span></div>
																		<div style={{float:'left' ,clear:'both', width:'350px'}}><span>{table_val['component_name']['base_line']}</span></div>
																	</td>
																</tr>
													</tbody>
												</table>
									 	</td>
								  </tr>
		})
	}
		return (
			 <section id="contentsection" className="contentarea">
		      <div className="inner-title-bg journey-tit-bg">
		        <h1> <span> <img src={process.env.PUBLIC_URL+'/images/recap-icon.jpg'} align="absmiddle" alt="" border="0" /> </span> Recap<br />
		          <span className="subtitle">Collection of notes prepared in Learning Rooms and Recaps of Learning Rooms.</span></h1>
		      </div>

		     <section id="semana-scroll-inner" className="scroll">
			  <section className="viewport">
			    <section className="overview">
			      <div className="inner-content">
			        <div className="recap-content">
				        <div className="recap-blue-box">
				          					Any time during your program sessions, you can view recap of your completed Learning Rooms,
							and the Notes prepared by you alongside.
						</div>
				        <div id="parentHorizontalTab" ref="parentHorizontalTab">
				            <ul className="resp-tabs-list hor_1" >
				            	<li key={`tab_0`}>LR-wise Recap</li>
				              	<li key={`tab_1`}>Module-wise Recap</li>
								<li key={`tab_2`}>DLR-wise Recap</li>
								<li key={`tab_3`}>DLR Module-wise Recap</li>
								
				            			{/* {(this.state.dlr_count!='0' && this.state.dlr_count!=undefined && this.state.dlr_count!='') &&
											<li key={`tab_2`}>DLR-wise Recap</li>
										}

										{(this.state.dlr_count!='0' && this.state.dlr_count!=undefined && this.state.dlr_count!='') &&
											<li key={`tab_3`}>DLR Module-wise Recap</li>
										} */}
				            </ul>
				            {this.state.recap_module_list}
				        </div>
			        </div>

			       <div className="recap-table-content">
			        <h2 className="recap-blue-title">Repeatable Components</h2>
					<div className="recap-blue-box">Any time during the program, you can visit the repeatable components. You can visit these any number of times, but scores will not change.</div>
			        <div className="recap-table viewobservers">
			           <table width="100%" cellSpacing="0" cellPadding="0" border="0" className="myjourney-table">
			              <thead>
			                <tr>
			                  <th>LR#</th>
			                  <th>Module name</th>
			                  <th>Component Name</th>
			                </tr>
			              </thead>
			                  
			                  {table_lr !='' ?
			                  	<tbody key="recap-tab">{table_lr}</tbody>
			                  	:
				                  <tbody key="recap-tab"><tr bgcolor='#FFFFFF'>
									 	<td colSpan="3" align="center" style={{textAlign:'center'}}>There are no repeatable components available at the moment.</td>
								  </tr>
								  </tbody>
								}
							
						</table>
						{table_dlr !='' ?
							<table width="100%" cellSpacing="0" cellPadding="0" border="0" className="myjourney-table">
				              <thead>
				                <tr>
				                  <th>DLR#</th>
				                  <th>Module name</th>
				                  <th>Component Name</th>
				                </tr>
				              </thead> 
				              	<tbody key="recap-tab">{table_dlr}</tbody>			                  	
							</table>
							:
							''
						}
					</div>
			        </div>

			      </div>
			    </section>
			  </section>
			</section>

			</section>
		);
	}
}

export default Recap;



// WEBPACK FOOTER //
// ./src/learning_records/recap/Recap.js